module.exports = __webpack_public_path__ + "img/drag.d976ce24.svg";